export async function hashSha256(value: string): Promise<string> {
  const data = new TextEncoder().encode(value);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}

export async function hashEmailSha256(email: string): Promise<string> {
  const normalizedEmail = email.trim().toLowerCase();
  return hashSha256(normalizedEmail);
}

/** Normalizes phone for Enhanced Conversions: digits only, US country code when 10 digits. */
export function normalizePhoneForHashing(
  phone: string,
  countryCode = "1"
): string | null {
  const digits = phone.replace(/\D/g, "");
  if (digits.length < 10) {
    return null;
  }
  if (digits.length === 10) {
    return `${countryCode}${digits}`;
  }
  return digits;
}

export async function hashPhoneSha256(
  phone: string,
  countryCode = "1"
): Promise<string> {
  const normalizedPhone = normalizePhoneForHashing(phone, countryCode);
  if (!normalizedPhone) {
    return "";
  }
  return hashSha256(normalizedPhone);
}
